module.exports = __webpack_public_path__ + "img/icon_shadow.a8209209.png";